import { DomainError } from "@econ-v1/domain";
export class SettingsCommandDispatcher {
    settings;
    next;
    constructor(settings, next) {
        this.settings = settings;
        this.next = next;
    }
    async execute(name, payload) {
        switch (name) {
            case "client-settings.set.v1": {
                const input = settingsSetPayload(payload);
                await this.settings.set(input);
                return { status: "committed" };
            }
            case "client-settings.delete.v1": {
                const input = settingsDeletePayload(payload);
                await this.settings.delete(input.key);
                return { status: "committed" };
            }
            default:
                if (this.next !== undefined)
                    return await this.next.execute(name, payload);
                throw new DomainError({ code: "not_found", message: "Host command is not registered" });
        }
    }
}
function settingsSetPayload(value) {
    const record = exactObject(value, ["key", "value"]);
    if (!nonEmptyString(record.key) || !("value" in record) || !isRepositoryJsonValue(record.value))
        invalid();
    return { key: record.key, value: record.value };
}
function settingsDeletePayload(value) {
    const record = exactObject(value, ["key"]);
    if (!nonEmptyString(record.key))
        invalid();
    return { key: record.key };
}
function exactObject(value, keys) {
    if (value === null || typeof value !== "object" || Array.isArray(value))
        invalid();
    const record = value;
    if (Object.keys(record).length !== keys.length || Object.keys(record).some((key) => !keys.includes(key)))
        invalid();
    return record;
}
function nonEmptyString(value) {
    return typeof value === "string" && value.trim().length > 0;
}
function isRepositoryJsonValue(value) {
    if (value === null || typeof value === "string" || typeof value === "boolean")
        return true;
    if (typeof value === "number")
        return Number.isFinite(value);
    if (Array.isArray(value))
        return value.every(isRepositoryJsonValue);
    if (typeof value !== "object")
        return false;
    const prototype = Object.getPrototypeOf(value);
    return (prototype === Object.prototype || prototype === null) && Object.values(value).every(isRepositoryJsonValue);
}
function invalid() {
    throw new DomainError({ code: "invalid_request", message: "Invalid client settings command payload" });
}
//# sourceMappingURL=settings-command-dispatcher.js.map